// extracted by mini-css-extract-plugin
export var btn = "EbookModal-module--btn--8aae9";
export var form = "EbookModal-module--form--0ffd7";
export var info = "EbookModal-module--info--e4df4";
export var inner = "EbookModal-module--inner--ac193";
export var modal = "EbookModal-module--modal--fdfbf";
export var success = "EbookModal-module--success--f50bd";
export var successCard = "EbookModal-module--successCard--3dfb4";